/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

function AppSelect({
  name,
  selectedValue,
  options,
  onSelect,
  isClearable,
  placeholder,
  className,
  appSelectClassName,
  selectWidth,
  errorText,
  label,
  maxheight,
  height,
  ...rest
}) {
  const menuPortalTarget =
    typeof document !== 'undefined' ? document.body : undefined;
  const isError =
    errorText &&
    errorText !== '' &&
    (selectedValue === '' ||
      selectedValue === undefined ||
      selectedValue === null);
  const selectedOption =
    selectedValue === '' ||
    selectedValue === undefined ||
    selectedValue === null ||
    options === undefined
      ? ''
      : options.find(
          (c) =>
            c.value.toString().toLowerCase() ===
            selectedValue.toString().toLowerCase(),
        );
  return (
    <div className={`app-text-input position-relative ${appSelectClassName}`}>
      <label
        className={`position-absolute z-1 text-input-label ${
          rest.required ? 'required' : ''
        }`}
      >
        {label}
      </label>
      <Select
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({
            ...base,
            zIndex: 99999,
            boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: maxheight,
            boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
          }),
          control: (base) => ({
            ...base,
            width: selectWidth,
            minWidth: selectWidth,
            height,
            borderRadius: '6px',
            borderColor: isError ? '#d31313' : '#848794',
          }),
          valueContainer: (base) => ({
            ...base,
            padding: height === '84px' ? '8px 16px' : '0.5rem',
            fontWeight: height === '84px' ? '600' : '',
            fontSize: height === '84px' ? '20px' : '',
          }),
        }}
        placeholder={placeholder}
        className={`app-select ${className}`}
        cacheOptions
        isClearable={isClearable}
        value={selectedOption}
        // value={selectedValue}
        options={options}
        onChange={(value) => onSelect(value, name)}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={menuPortalTarget}
        {...rest}
      />
      {isError && <small className="app-error-text">{errorText}</small>}
    </div>
  );
}

AppSelect.defaultProps = {
  isClearable: true,
  selectedValue: null,
  className: '',
  appSelectClassName: '',
  selectWidth: '',
  errorText: '',
  label: '',
  maxheight: '200px',
  height: '50px',
};

AppSelect.propTypes = {
  isClearable: PropTypes.bool,
  className: PropTypes.string,
  appSelectClassName: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  selectedValue: PropTypes.any,
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  selectWidth: PropTypes.string,
  maxheight: PropTypes.string,
  errorText: PropTypes.any,
  label: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  height: PropTypes.string,
};

export default AppSelect;
